import React from 'react';
import LoginSection from '../Components/Login';

const LoginPage = () => (
  <LoginSection />
);

export default LoginPage;
